<template>
    <div class="checkbox">
        <div class="title">
        <Ordervue :order="order" :total='total'></Ordervue>
        <span v-html="data.question" class="question"> </span>
        （{{data.questionscore}}分）
        <span class="type">主观题</span>
        <span style="margin-right:10px;">
            总数：{{data.total}}
        </span>
        <span>    
            待阅：{{data.dcount}}
        </span>
        </div>
    </div>
</template>
<script>
import Ordervue from './issue/order'
export default {
    name:"question",
    data(){
        return {
            value:[]
        }
    },
    mounted(){
     console.log(this.data)
    },
    props:["order","data","total"],
    components:{
       Ordervue
    },
    methods:{

    }
}
</script>
<style lang="css" scoped>
.title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.question{
    flex-grow: 1;
}
.checkbox{
    margin-top: 0.3rem;
    text-align: left;
    color: #575e6b;
    line-height: 0.36rem;
    font-size: 0.14rem;
    background: #f2f4f8;
}
.type{
    display: inline-block;
    width: 0.6rem;
    height: 0.2rem;
    line-height: 0.18rem;
    border: 1px solid #c34e00;
    background: #ffdcc4;
    color: #c34e00;
    font-size: 0.14rem;
    text-align: center;
    border-radius: 2px;
    margin: 0 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/question.vue